/** Harbor internal account used for public homepage demo booking + Demo Calls UI. */
export const HARBOR_DEMO_ACCOUNT_ID = '67653f5095d66c15d143216f';
